import { CalendarGroup, GroupType } from 'owa-calendar-surface-calendars-store';
import { getCalculatedFolderId, Calendar } from 'owa-calendar-cache';
import { getUserMailboxInfo, MailboxInfo } from 'owa-client-ids';
import CalendarEntry from 'owa-service/lib/contract/CalendarEntry';
import _CalendarGroup from 'owa-service/lib/contract/CalendarGroup';
import LocalCalendarEntry from 'owa-service/lib/contract/LocalCalendarEntry';
import LinkedCalendarEntry from 'owa-service/lib/contract/LinkedCalendarEntry';

export function convertToCalendarType(
    cacheCalendarEntry: CalendarEntry | LocalCalendarEntry | LinkedCalendarEntry,
    userMailboxInfo?: MailboxInfo
): Calendar {
    let entryId = cacheCalendarEntry.ItemId.Id;
    let calcFolderId = getCalculatedFolderId(cacheCalendarEntry).Id;
    if (!userMailboxInfo) {
        userMailboxInfo = getUserMailboxInfo();
    }

    return {
        id: { id: entryId, mailboxInfo: userMailboxInfo },
        calculatedFolderId: calcFolderId,
        displayName: cacheCalendarEntry.CalendarName,
        colorScheme: null,
    };
}

export function convertToGroupType(
    cacheCalendarGroup: _CalendarGroup,
    userMailboxInfo?: MailboxInfo
): CalendarGroup {
    if (!userMailboxInfo) {
        userMailboxInfo = getUserMailboxInfo();
    }
    return {
        id: { id: cacheCalendarGroup.ItemId.Id, mailboxInfo: userMailboxInfo },
        groupId: cacheCalendarGroup.GroupId,
        displayName: cacheCalendarGroup.GroupName,
        groupType: cacheCalendarGroup.GroupType.valueOf() as GroupType,
    };
}
